
import { computed, defineComponent, ref, onMounted } from "vue-demi";
import pdf from "@teckel/vue-pdf";
import { SMDocumentsV2 } from "@/store";

export default defineComponent({
  name: "PDFViewer",
  components: {
    pdf,
    PDFViewerToolbar: () => import("@/modules/Documents/PDFViewerToolbar.vue"),
  },
  props: {
    modelValue: Boolean,
    fileId: {
      type: Number,
      default: 0,
    },
    fileIndex: {
      type: Number,
      default: 0,
    },
    link: {
      type: String,
      default: "",
    },
    name: {
      type: String,
      default: "",
    },
    showToggleFiles: {
      type: Boolean,
      default: false,
    },
  },

  emits: ["update:modelValue", "toggle-file"],

  setup(props, { emit }) {
    const isOpen = computed({
      get: () => props.modelValue,
      set: (value) => emit("update:modelValue", value),
    });

    const close = () => {
      isOpen.value = false;
    };

    const preview = ref({
      link: props.link,
      name: props.name,
      currentPage: 1,
      pageCount: 1,
      zoom: 50,
      minZoom: 20,
      maxZoom: 100,
    });

    onMounted(async () => {
      if (!props.fileId) return;

      try {
        const file = await SMDocumentsV2.getFileData(props.fileId);

        if (file && typeof file.link === "string") {
          preview.value.link = file.link;
        } else {
          preview.value.link = "";
        }
        preview.value.name = file.name || "Unnamed File";

        Object.assign(preview.value, file);
      } catch (error) {
        console.error("Failed to load file data:", error);
      }
    });

    function setPageCount(payload) {
      preview.value.pageCount = payload;
    }

    function setCurrentPage(payload) {
      preview.value.currentPage = payload;
    }

    const computedPreviewStyle = computed(() => {
      return {
        width: `${preview.value.zoom}%`,
        margin: "0 auto",
      };
    });

    function downloadFile() {
      const { link, name } = preview.value;

      SMDocumentsV2.downloadFile({ link, name });
    }

    function toggleFile(direction: "prev" | "next") {
      emit("toggle-file", {
        index: props.fileIndex,
        direction,
      });
    }

    return {
      isOpen,
      close,
      preview,
      setPageCount,
      setCurrentPage,
      computedPreviewStyle,
      downloadFile,
      toggleFile,
    };
  },
});
